import React from 'react';
import { Carousel } from 'react-bootstrap';

const VirtualShop = () => {
    return (
        <div className="roadRiderzProject">
        <h1 className="projects-Header">Virtual Shop</h1>
        <div className="row site-details-rrz">
          <div className="col-md-6 p-3">
            <p>
              * This is e-commerce related website, user can buy &
              remove product.
            </p>
            <p>
              * Using technologies are ReactJS, NodeJS, ExpressJS, MongoDB,
              Firebase, Heroku.
            </p>
            <p>
              * A fully functional full-stack web app basses on MERN stack. It has
              admin panel.
            </p>
            <p>* This Site fully responsive for large and small device.</p>
            <p>
              * This Site has Authentication system like google signin, register
              for new user with firebase.
            </p>
           
          </div>
          <div className="col-md-6 p-3">
            <Carousel fade>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/cbd7dhf/vsHome.png"
                  alt="First slide"
                />
                <Carousel.Caption>
                  {/* <h3>First slide label</h3>
                  <p>
                    Nulla vitae elit libero, a pharetra augue mollis interdum.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/mqG4PC6/vshop.png"
                  alt="Second slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Second slide label</h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/nLCvsgz/Screenshot-91.png"
                  alt="Third slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/Dwd7VLn/Screenshot-90.png"
                  alt="Third slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Fourth slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
       <div className="siteInfo">
       <h3 className="seeLive">See Live: </h3>
        <span >
          {" "}
          <a className="liveSite" target="_blank" href="https://virtual-shop-bd.netlify.app/"><b>LiveSite</b></a>
        </span>
        <span >
          <a className="clientSide" target="_blank" href="https://github.com/Iasir-Arafat-riaz/E-Commerce-Site"><b>ClientSideCode</b></a>
        </span>
        <span>
          <a className="serverSide" target="_blank" href="https://github.com/Iasir-Arafat-riaz/E-Commerce-Site-Node-MongoDB-Server"><b>ServerSideCode</b></a>
        </span>
       </div>
      </div>
    );
};

export default VirtualShop;